var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _vm.fields.length == 0
        ? _c("div", { key: "empty", staticClass: "empty" }, [
            _vm._v(" " + _vm._s(_vm.$ct("no-fields-added")) + " "),
          ])
        : _vm._e(),
      _c(
        "w-sortable",
        {
          attrs: {
            tag: "w-list",
            "target-class": "handle",
            items: _vm.fields,
            "keep-in-y": "",
          },
          on: {
            drop: function ($event) {
              return _vm.emitChanged()
            },
          },
        },
        [
          _vm._l(_vm.fields, function (conf) {
            return _c(
              "w-list-item",
              { key: conf.uid, attrs: { "show-handle": "" } },
              [
                _c("w-list-item-text", [_vm._v(_vm._s(_vm.getText(conf)))]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.edit"),
                            expression: "$ct('common.edit')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.editItem(conf)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.delete"),
                            expression: "$ct('common.delete')",
                          },
                        ],
                        staticClass: "danger",
                        on: {
                          click: function ($event) {
                            return _vm.removeItem(conf)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              key: "add",
              on: {
                click: function ($event) {
                  return _vm.addClicked()
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("w-list-item-text", [_vm._v(_vm._s(_vm.$ct("common.add")))]),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditItem != null } },
        [
          _vm.toEditItem
            ? _c(
                "w-card",
                { attrs: { "max-width": "500" } },
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.modalTitle))]),
                  _c(
                    "w-scroll-view",
                    { attrs: { tag: "w-card-content" } },
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("app-column-select", {
                                attrs: { model: _vm.model },
                                model: {
                                  value: _vm.editProp,
                                  callback: function ($$v) {
                                    _vm.editProp = $$v
                                  },
                                  expression: "editProp",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "cancel",
                          attrs: { icon: "ban" },
                          on: {
                            click: function ($event) {
                              _vm.toEditItem = null
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: { icon: "check" },
                          on: {
                            click: function ($event) {
                              return _vm.confirm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }